export default __webpack_public_path__ + "static/media/Inter-Medium.a162b6eb.ttf";